import { SourceFileResponseList } from "@/features/clientProjectDetails/types";
import {
  FileStatusType,
  SelectedFilesWithMultiParts
} from "@/features/createProject/api";
import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { FileListItem } from ".";

interface SingleFormatFileListProps {
  fileCount: number;
  fileTitle: string;
  uploadedFiles?: SourceFileResponseList;
  currentFiles: {
    [key: string]: SelectedFilesWithMultiParts;
  };
  handleUnlinkedFileUploads: (fileKey: string) => void;
  handleFileRetry: (fileKey: string) => void;
  handleRemoveFileForUpload: (fileKey: string) => void;
}

export const SingleFormatFileList = ({
  fileCount,
  fileTitle,
  uploadedFiles,
  currentFiles,
  handleUnlinkedFileUploads,
  handleFileRetry,
  handleRemoveFileForUpload
}: SingleFormatFileListProps): React.ReactNode => {
  return (
    <Box>
      <Box
        sx={{
          bgcolor: "text.selected"
        }}
        px={2}
        py={1}
      >
        <Typography>
          {fileTitle}({fileCount})
        </Typography>
      </Box>
      <Stack overflow={"auto"} height={"100%"} maxHeight={"70vh"}>
        {uploadedFiles && Object.keys(uploadedFiles)?.length
          ? Object.keys(uploadedFiles).map((fileKey) => (
              <FileListItem
                key={fileKey}
                fileKey={fileKey}
                fileName={
                  uploadedFiles[fileKey].originalFileName ||
                  uploadedFiles[fileKey].fileName ||
                  ""
                }
                fileStatus={
                  (uploadedFiles[fileKey].fileStatus || "") as FileStatusType
                }
                onFileRetry={() => handleFileRetry(fileKey)}
                onFileRemove={() => handleUnlinkedFileUploads(fileKey)}
                fileType={uploadedFiles[fileKey].fileType}
              />
            ))
          : null}
        {Object.keys(currentFiles).map((fileKey) => (
          <FileListItem
            key={fileKey}
            fileKey={fileKey}
            fileName={currentFiles[fileKey].fileData.name || ""}
            fileStatus={(currentFiles[fileKey].status || "") as FileStatusType}
            metaData={currentFiles[fileKey].meta}
            fileType={
              currentFiles[fileKey].fileData.type?.startsWith("audio/")
                ? "BG_AUDIO"
                : "VIDEO"
            }
            onFileRetry={() => handleFileRetry(fileKey)}
            onFileRemove={() => handleRemoveFileForUpload(fileKey)}
          />
        ))}
      </Stack>
    </Box>
  );
};
